const rankings = [
  { rank: 1, title: '在线吃瓜线路一', desc: '最稳定官方主线路，访问速度最快，推荐首选', hot: '98%', change: 'up' },
  { rank: 2, title: '91在线吃瓜网官方入口', desc: '最新官方域名入口，每日实时同步内容更新', hot: '95%', change: 'up' },
  { rank: 3, title: '在线吃瓜备用网址A', desc: '高可用备用通道，主线路异常时自动切换', hot: '91%', change: 'up' },
  { rank: 4, title: '在线吃瓜备用网址B', desc: '海外优化线路，适合境外用户高速访问', hot: '87%', change: 'stable' },
  { rank: 5, title: '在线吃瓜移动端入口', desc: '手机专属适配页面，流量消耗更低更流畅', hot: '84%', change: 'up' },
];

const changeIcon = (c: string) => {
  if (c === 'up') return <i className="ri-arrow-up-line text-green-400"></i>;
  if (c === 'down') return <i className="ri-arrow-down-line text-red-400"></i>;
  return <i className="ri-subtract-line text-foreground-500"></i>;
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100/50">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex items-center gap-3 mb-10">
          <span className="w-8 h-8 rounded-lg bg-accent-500/15 flex items-center justify-center flex-shrink-0">
            <i className="ri-trophy-line text-accent-400"></i>
          </span>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-100">入口热度榜</h2>
        </div>
        <div className="grid gap-3">
          {rankings.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 rounded-xl bg-background-50 border border-background-300/30 hover:border-primary-500/20 transition-colors duration-200"
            >
              <span className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold flex-shrink-0 ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-accent-500/30 text-accent-400' :
                item.rank === 3 ? 'bg-secondary-500/30 text-secondary-400' :
                'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-200 truncate">{item.title}</h3>
                <p className="text-xs text-foreground-600 mt-0.5 truncate">{item.desc}</p>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-sm font-bold text-foreground-300">{item.hot}</span>
                {changeIcon(item.change)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}